import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { Grid, Box, Typography, Select, FormControl, MenuItem } from "@mui/material";
import { currentMonth, getByWeekDate, fancyTimeHhMmSs } from "../../Js/TimeAndDate";

import { getTrainerUsageData, getAssignmentAssignData, getUserLogs } from "../Report/Services";

const ProfileActivity = (props) => {

    // Redux state
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

    // State
    const [numWeek, setNumWeek] = useState(7);
    const [trainerReportData, setTrainerReportData] = useState([]);
    const [totalAssignments, setTotalAssignments] = useState(0);
    const [totalPendingEval, setTotalPendingEval] = useState(0);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    // Use Effect
    useEffect(() => {
        let weekDateData = getByWeekDate(numWeek);
        setStartDate(weekDateData.startOfWeek);
        setEndDate(weekDateData.endOfWeek);
        // console.log("weekDateData======>",weekDateData);
    }, [numWeek]);

    useEffect(() => {
        if (startDate !== null && endDate !== null) {
            fetchActivityReports();
            getEvaluations();
        }
    }, [startDate, endDate]);

    // Functions
    const handleWeekChange = (event) => {
        setNumWeek(event.target.value);
    };

    const fetchActivityReports = async () => {
        let params = {
            query: {
                'site_uuid': userInfo.site_uuid,
                'fromDate': startDate,
                'toDate': endDate,
                'reportType': 'teacherWise',
                'user_uid': [userInfo.uid]
            }
        };
        let resTrainerData = await getTrainerUsageData(params);
        //console.log("resTrainerData.data", resTrainerData.data);

        let params1 = {
            query: {
                'site_uuid': userInfo.site_uuid,
                'created_by': userInfo.uid,
                'created_at': {
                    $gte: startDate,
                    $lte: endDate
                },
                $limit: 0
            }
        };
        let resAssignmentAssignData = await getAssignmentAssignData(params1);
        if (resAssignmentAssignData.data.total > 0) {
            setTotalAssignments(resAssignmentAssignData.data.total);
        }
        //console.log("resTrainerData.data====>", resTrainerData.data.length);
        if (resTrainerData.data.length > 0) {
            setTrainerReportData(resTrainerData.data);
        } else {
            setTrainerReportData([]);
        }
    };

    const getEvaluations = async () => {
        let params = {
            query: {
                $select: ['target'],
                verb: 'attemptAssignment',
                outcome: {
                    isEvaluated: 'pending'
                },
                site_uuid: userInfo.site_uuid,
                created_at: {
                    $gte: startDate,
                    $lte: endDate
                },
                $limit: -1,
            }
        };
        console.log("getEvaluations====>", params);

        let userLogsData = await getUserLogs(params);
        let targetLogIds = userLogsData.data.map((obj) => {
            return obj.target;
        });

        let uniqueLogsIds = [...new Set(targetLogIds)];
        console.log("uniqueLogsIds====>", uniqueLogsIds);

        if (uniqueLogsIds.length > 0) {
            let paramsAssignment = {
                query: {
                    $select: ['uid'],
                    site_uuid: userInfo.site_uuid,
                    created_by: userInfo.uid,
                    uid: uniqueLogsIds,
                    $limit: -1
                }
            };
            let resAssignmentAssignData = await getAssignmentAssignData(paramsAssignment);
            console.log("getEvaluations====>", resAssignmentAssignData.data);

            if (resAssignmentAssignData.data.length > 0) {
                let assignmentIds = resAssignmentAssignData.data.map((obj) => {
                    return obj.uid;
                });
                let totPendingEval = 0;
                targetLogIds.forEach((targetId, idData) => {
                    let found = assignmentIds.includes(targetId);
                    if (found) {
                        totPendingEval++;
                    }
                });
                console.log("totPendingEval", totPendingEval);
                setTotalPendingEval(totPendingEval);
            }

        }


    }

    return (
        <>
            <Box sx={{ flexGrow: 1 }}>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Grid item>
                        <Typography sx={{ color: "#DB8829", fontSize: "1.1rem", fontWeight: '500', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                            Time spent (HH:MM:SS)
                        </Typography>
                    </Grid>
                    <Grid>
                        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                            <Select
                                value={numWeek}
                                onChange={handleWeekChange}
                                displayEmpty
                                sx={{
                                    color: "#CCCCCC",
                                    borderRadius: 10,
                                    fontSize: "0.8rem",
                                }}
                            >
                                <MenuItem value={7} sx={{ fontSize: "0.8rem", fontWeight: '500', '@media (min-width: 1636px)': { fontSize: '1rem' } }}>
                                    1 Week
                                </MenuItem>
                                <MenuItem value={14} sx={{ fontSize: "0.8rem", fontWeight: '500', '@media (min-width: 1636px)': { fontSize: '1rem' } }}>
                                    2 Week
                                </MenuItem>
                                <MenuItem value={21} sx={{ fontSize: "0.8rem", fontWeight: '500', '@media (min-width: 1636px)': { fontSize: '1rem' } }}>
                                    3 Week
                                </MenuItem>
                                <MenuItem value={28} sx={{ fontSize: "0.8rem", fontWeight: '500', '@media (min-width: 1636px)': { fontSize: '1rem' } }}>
                                    4 Week
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                backgroundColor: "#DB8829",
                                borderRadius: 15,
                                px: 2,
                                py: 1,
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "#FFFFFF",
                                    fontWeight: "bold",
                                    fontSize: "1rem",
                                    fontWeight: '500', '@media (min-width: 1636px)': { fontSize: '1.4rem' }
                                }}
                            >
                                {(trainerReportData[0]) ? fancyTimeHhMmSs(trainerReportData[0].totalTime) : '00:00:00'}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box sx={{ flexGrow: 1, mt: 4 }}>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Grid item>
                        <Typography sx={{ color: "#DB8829", fontSize: "1.1rem", fontWeight: '500', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                            Evaluation pending
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                backgroundColor: "#DB8829",
                                borderRadius: 15,
                                px: 2,
                                py: 1,
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "#FFFFFF",
                                    fontWeight: "bold",
                                    fontSize: "1rem",
                                    fontWeight: '500', '@media (min-width: 1636px)': { fontSize: '1.4rem' }
                                }}
                            >
                                {totalPendingEval}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box sx={{ flexGrow: 1, mt: 4 }}>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Grid item>
                        <Typography sx={{ color: "#DB8829", fontSize: "1.1rem", fontWeight: '500', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                            Alloted the assignment
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                backgroundColor: "#DB8829",
                                borderRadius: 15,
                                px: 2,
                                py: 1,
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "#FFFFFF",
                                    fontWeight: "bold",
                                    fontSize: "1rem",
                                    fontWeight: '500', '@media (min-width: 1636px)': { fontSize: '1.4rem' }
                                }}
                            >
                                {totalAssignments}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};
export default ProfileActivity;